
/**
 * Props参数说明
 * @memberof CardPagination
 * @typedef Props
 * @property {string} id 
 * @property {number} status=1 1表示将激活id修改为allpks中已有的id；2表示在allpks中新增id，并作为激活id使用；3表示在allpks中删除该id
*/

/**
 * 设置显隐性
 * @memberof CardPagination
 * @param {string} cardPaginationId 翻页按钮id, 历史代码依赖问题: 目前没有用到，可以随便传一个字符串
 * @param {boolean} flag 卡片场景使用：缓存命名空间，单页应用缓存使用 
 */
export function setCardPaginationVisible(cardPaginationBtn, flag) {
    if (this.myCardPagination && this.myCardPagination.state) {
        //if (flag != this.myCardPagination.state.visible) {
        this.myCardPagination.setState({ visible: flag });
        //}
    }
}

export function setCardPaginationId(idObj = {}) {
    if (this.myCardPagination && this.myCardPagination.state && idObj && idObj.id) {
        if (!idObj.status) {
            idObj.status = 1;
        }
        if (idObj.status == 1) {//修改
            this.myCardPagination.setState({ activeId: idObj.id });
        }
        if (idObj.status == 2) {//新增
            this.myCardPagination.state.allpks.push(idObj.id);
            this.myCardPagination.setState({
                activeId: idObj.id,
                allpks: this.myCardPagination.state.allpks,
            });
        }
        if (idObj.status == 3) {//删除
            let index = this.myCardPagination.state.allpks.indexOf(idObj.id);
            if (index != -1) {
                this.myCardPagination.state.allpks.splice(index, 1);
                this.myCardPagination.setState({ allpks: this.myCardPagination.state.allpks });
            }
        }
    }
}

/**
 * 获取传入id的下一个pk, 若是allpks中最后一个pk,则返回上一个，否则返回下一个
 * @memberof CardPagination
 * @param {Props} props
 */
export function getNextCardPaginationId(idObj) {
    if (this.myCardPagination && this.myCardPagination.state) {
        if (idObj && idObj.id) {
            let allpks = this.myCardPagination.state.allpks;
            if (allpks.length > 1) {
                let index = allpks.indexOf(idObj.id);
                if (index == allpks.length - 1) { //是最后一条
                    return allpks[allpks.length - 2];
                } else { //不是最后一条
                    return allpks[index + 1];
                }
            }
        }
    }

}

/**
 * 设置翻页器的allpks
 * @memberof CardPagination
 * @param {Array} allpks 翻页器翻页id组成的数组
 * @param {function} success allpks页面更新成功后的回调
 */
export function setCardPaginationAllpks(allpks, success) {
    if (this.myCardPagination && this.myCardPagination.state && Array.isArray(allpks)) {
        this.myCardPagination.setState({ allpks: allpks }, ()=>{
            typeof success === 'function' && success();
        });
    }
}

/**
 * 设置翻页器的激活id
 * @memberof CardPagination
 * @param {string} id 设置翻页器当前激活id
 */
export function setCardPaginationActiveId(id) {
    if (this.myCardPagination && this.myCardPagination.state) {
        this.myCardPagination.setState({ activeId: id });
    }
}

/**
 * 设置翻页器的事件监听
 * @memberof CardPagination
 * @param {string} eventName 事件名
 * @param {function} callback 事件回调函数
 */
export function addEventListener(eventName, callback) {
    if (this.myCardPagination && this.myCardPagination.state) {
        this.myCardPagination.listener[eventName] = callback;
    }
}
